// src/components/dashboard/user-requests/utils/requestCreators.ts
import { AddChildRequestData, AddInfoRequestData } from '../types/request';

import { generateId } from '@/utils/generators';

export function createChildRequest(
  userId: string,
  username: string,
  data: AddChildRequestData
) {
  console.log({userId, username, data})
  return {
    id: generateId(),
    requesterId: userId,
    requesterName: username,
    childName: data.childName,
    phoneNumber: data.phoneNumber,
    status: 'pending' as const,
    timestamp: Date.now(),
    parentId: data.parentId
  };
}

export function createInfoRequest(
  userId: string,
  username: string,
  phoneNumber: string,
  data: AddInfoRequestData
) {
  return {
    id: generateId(),
    requesterId: userId,
    requesterName: username,
    phoneNumber,
    status: 'pending' as const,
    timestamp: Date.now(),
    personalInfo: data
  };
}
